import * as Sentry from '@sentry/react';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { ArrowForward, Delete, Star, Edit } from '@mui/icons-material';
import { styled as muiStyled } from '@mui/material/styles';
import Acent from 'components/Acent';

import AssignmentClassConfig from "modules/studentGroup/differnation/assignmentClassConfig";
import COLOR from 'utils/constants/color';
import CustomDateTimePicker from 'components/DateTimePicker';
import Loading from 'components/Loading';
import ModalMenu from 'components/Modals';
import { Snackbar, Alert } from '@mui/material';
import Tag from 'components/Tag';
import moment from 'moment';
import styled from 'styled-components';
import useMobileDeviceDetection from 'containers/chat/hooks';
import { AiConfiguration } from 'components/AssignmentAiConfig';
import { Col, Row } from 'antd';
import { GRADE_TYPE_ALL, GRADE_TYPE_CANVAS } from 'utils/config/reference';
import { SoyStoryImg, SoyHistoriasNew } from 'utils/assets/images';
import { filter, get, map, find, findIndex } from "lodash";
import { graphic_data } from 'utils/constants/graphic_org';
import { handleDeleteCanvasAssignment } from "store/canvas/thunks";
import { handleDeleteClassActivity } from 'store/classActivities/thunks';
import { handleGetAssignmentStatus } from 'store/activities/thunks';
import { handleDeleteGoogleAssignment } from 'store/googleClassRoom/thunks';
import { handleDeleteSchoologyAssignment } from 'store/schoology/thunks';
import { getNumberMask, imageFetchDinamic, imageFetchFromPodcast, isVideo, groupLinkedSection } from 'utils/lib/ebookHelper';
import { isBeforTime, getCurrentSemStartAndEndDate, isAfterTime } from 'utils/methods/math';
import { useParentOrgId } from 'store/organizations/selectors';
import { useClassUsers } from 'store/userClasses/selectors';
import { useCollectionNotification } from 'utils/methods/firebaseNotification';
import { useExams } from 'store/exams/selectors';
import { useResources } from 'store/resources/selectors';
import { useRubrices } from 'store/rubric/selectors';
import { useSchoologyAssignment, useSchoologyGradeCategory } from "store/schoologyauth/selectors";
import { useActivities, useOwnGraphicOrganizers } from 'store/activities/selectors';
import { useClassActivities } from 'store/classActivities/selectors';
import { useAssignmentCoverTitle } from 'components/hooks/pageCover/useAssignmentCoverTitle';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { v4 } from 'uuid';
import GraphicOrganizerEditPreview from 'components/GraphicOrganizerEditPreview';

import {
    Button,
    Checkbox,
    FormControlLabel,
    Modal,
    Switch,
    TextField,
    ListItemText,
    MenuItem,
    FormControl,
    Select,
    InputLabel,
    Autocomplete,
    Chip,
    IconButton
} from '@mui/material';
import useCurrentAssignment from 'components/hooks/assignment/useCurrentAssignment';
import SentryWrap from 'components/Sentry';
import { useQuizzes } from 'store/quizzes/selectors';
import { useBookUnits } from 'store/booksUnits/selectors';
import { useStory } from 'store/story/selectors';
import { useClassQuizzes } from 'store/classQuizzes/selectors';
import { graphic_activity } from 'utils/constants/graphic_org';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { usePageCover } from 'components/hooks/pageCover/pageCover';
import { shouldUseDeepLinking } from 'utils/deepLinkHelper';

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------








//  -- Components ---------------------








//  -- Constants ----------------------




























//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const Container = styled.div`
    border-top: 1px solid ${COLOR.black700};
    margin-top: 24px;
    padding-top: 40px;
    width: 100%;
`;

const Description = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 48px;
`;

const Header = styled(Description)`
    color: ${COLOR.black100};
    font-size: 28px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 16px;
`;

const Note = styled.span`
    color: ${COLOR.black400};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 16px;
`;

const Wrapper = styled.form`
    margin: 0px auto;
    width: 100%;
    position: relative;
    top: 0px; 
    padding-bottom: 50px;
`;


const ModalContent = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    max-width: 320px;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
`;

const ModalRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 16px;
    width: 100%;
`;
const Image = styled.img`
    background-color: ${COLOR.white};
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    height: auto;
    width: 100%;
`;

const ImageContiner = styled.div`
    background-color: transparent;
    border: none;
    flex: 1;
    outline: none;
    width: 100%;
    margin-right: 16px;
    padding-right: 10px;
    position: relative;
    @media screen and (max-width: 576px){
        padding-right: 0px;
    }
        @media screen and (max-width: 1366px){
            display:none;
        }
`;

const ImageStoryTitle = styled.div`
    position: absolute;
    top: 54.5%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    text-align: center;
    font-weight: bold;
    font-size: 32px;
    z-index: 1;
`;

const GraphicImageWrapper = styled.div`
    position: relative;
    width: 100px;
    display: inline-block;
`;

const EditIconButton = muiStyled(IconButton)({
    position: 'absolute !important',
    top: '-8px !important',
    right: '-8px !important',
    backgroundColor: 'white !important',
    padding: '4px !important',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2) !important',
    '&:hover': {
        backgroundColor: '#f0f0f0 !important'
    }
});

const DisabledInputWrapper = styled.div`
    width: 100%;
    cursor: ${props => props.isDisabled ? 'not-allowed' : 'default'};
    
    & .MuiTextField-root {
        pointer-events: ${props => props.isDisabled ? 'none' : 'auto'};
    }
`;

const StyledFormControl = muiStyled(FormControl)(({ theme }) => ({
    margin: '2px',
    width: "100%",
    minWidth: 120
}));

const StyledFormControlStudent = muiStyled(FormControl)({
    backgroundColor: "#fff"
});

const StyledFormControlLabel = muiStyled(FormControlLabel)({
    '&.MuiFormControlLabel-root': {
        marginBottom: '25px',
        width: '300px'
    },
    '&.rootDif': {
        width: '200px'
    },
    '&.rootDifFull': {
        width: "fit-content"
    }
});

const StyledSwitch = muiStyled(Switch)({
    '&.MuiSwitch-sizeSmall': {
        width: '40px',
        height: '25px'
    },
    '& .Mui-checked': {
        transform: 'translateX(17px) !important'
    }
});

const StyledCheckbox = muiStyled(Checkbox)({
    '&.Mui-checked': {
        color: `${COLOR.green}!important`
    }
});

const StyledLabel = muiStyled('span')({
    textTransform: 'uppercase'
});

const ITEM_HEIGHT = 48;
const CHAPTER_ID_INFORMATE = '41';
const CHAPTER_ID_BALCON = '33';
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
    getContentAnchorEl: () => null,
};


const customEvent = (id,value) =>{
    return ({ target: { id: id, value: value } })
}
const ActivityForm = ({
    data,
    selectedAssignments = [],
    handleChange,
    handleSubmit,
    setDurationSection,
    durationSection,
    loading,
    userClasses,
    currentClass,
    onClose,
    booksAllList,
    onDelete,
    currentUser,
    handleRubric = () => null,
    setTemplateType = () => null
}) => {
    const showAlert = useAlert();
    const deviceType = useMobileDeviceDetection();
    const dispatch = useDispatch();
    const AllRubricsData = useRubrices();
    const classUsers = useClassUsers();
    const {createCollectionNotification} = useCollectionNotification();
    const activities = useActivities();
    const quizzes = useQuizzes();
    const classActivities = useClassActivities();
    const classQuizzes = useClassQuizzes();
    const ownGraphicOrganizer = useOwnGraphicOrganizers();
    const [graphicOrganizerEditModalOpen, setGraphicOrganizerEditModalOpen] = useState(false);
    const [useCustomGraphicOrganizer, setUseCustomGraphicOrganizer] = useState(false);
    const useCustomGraphicOrganizerRef = useRef(false);
    const location = useLocation();
    const search = queryString.parse(location.search);
    const level = search.level || '';
    const currentChapter = search.chapter || data?.chapter || data?.data?.chapter;
    const currentPage = parseInt(search.page) || parseInt(data?.page) || parseInt(data?.data?.page) || 1;
    const [dataLoading, setDataLoading] = React.useState(false);
    const [submissionLoading, setSubmissionLoading] = React.useState(false);
    const resources = useResources();
    const story = useStory();
    const CHAPTER_ID = get(find(story, ["id", search.id]),"bookId");

    const [initialDueDate,setInitialDueDate] = useState(null)
    const [initialLateDate,setInitialLateDate] = useState(null)
    const [deleteClassAssignedActivityToggle, setdeleteClassAssignedActivityToggle] = React.useState(false);
    const [schoologyGradeCategory,,schoologyAllClassGradeCategory] = useSchoologyGradeCategory()
    const isSchoologyUser = currentUser && currentUser.schoologyid ? true : false;
    const isCanvas_user = currentUser && currentUser.canvas_id;
    const isGoogleUser = currentUser && currentUser.googleId;
    const isExternalToolMode = shouldUseDeepLinking();
    const [initialData,setInitialData] = useState(null)
    const [,listSchoologyAssignment ] = useSchoologyAssignment()
    const parentOrgId = useParentOrgId();
    const currentSemDateAndTime = getCurrentSemStartAndEndDate(parentOrgId)
    const [openAlert, setAlert] = React.useState({ open: false, message: "" });
    const bookUnitList = useBookUnits();
    const UNIT_PAGES = get(find(bookUnitList, ['bookId', currentChapter]), 'pages', []);

    const bookDataInformate = filter(UNIT_PAGES, (item) => item.id === search.id)[0] ?? {};
    const CHAPTER_STORY_PAGES = get(find(story, ["id", search.id]), "levels", []);

    const CHAPTER_STORY_PAGE = find(CHAPTER_STORY_PAGES, item => item.level === level)  ?? {};

    const CHAPTER_PAGES = get(find(bookUnitList, ['bookId', currentChapter]), 'pages', []);
    const bookDataBalcon = filter(CHAPTER_PAGES, (item) => item.id === search.id)[0] ?? {};

    const dispNameRef = useRef()
    // Find current unit based on current page
    const currentUnit = useMemo(() => {
      if (!booksAllList || !currentChapter) return null;
      const currentBook = booksAllList.find((book) => book.id === currentChapter);
      const currentBookUnits = currentBook?.subTopics;
      const getCurrentUnit = find(
        currentBookUnits,
        (x) =>
          currentPage >= parseInt(x.startPage, 10) && currentPage <= parseInt(x.finishPage, 10),
      );
      return getCurrentUnit;
    }, [booksAllList, currentChapter, currentPage]);

    
    const [initData,setInitData] = useState(null);
    const [searchInputValue, setSearchInputValue] = useState("");
    const [ai_grading_config,setAi_grading_config] = useState({})
    const filterClassUsers = filter(classUsers, (user) => user?.role !== 'teacher' && user?.active === true).map(user => user.id);
    const [errorForDateConfig, setErrorForDateConfig] = useState({
        lateDate: null,
        dueDate: null,
        dueDateDif: null,
        classCnfError: []
    })
    const [addedRubric, setAddedRubric] = useState(null);
    const [alreadyAssignedClassIds, setAlreadyAssignedClassIds] = useState([]);
    const  {checkAssignmentHaveSubmission} = useCurrentAssignment(data?.data?.id);
    const isEditing = get(data, "editing", false)
    const prevData = useRef()
    if(data&&data.lateDate=="null"){
        data.lateDate = null;
    }
    const exams = useExams();
    const is_exam = useMemo(() => {
        const _chapter = data.chapter ? data.chapter : data?.data?.chapter;
        const examBookIds = exams ? exams.flatMap(entry => entry.exams.map(exam => `${exam.bookId}`)) : []
        return _chapter && Array.isArray(examBookIds) ? examBookIds.includes(_chapter) : false
    }, [data, exams])


    const assignmentOptions = useMemo(() => {
        const allAssignments = [...activities, ...quizzes];
        const allClassAssignments = [...classActivities, ...classQuizzes];
        
        const currentBookActivities = filter(
          allAssignments,
          (activity) => (activity.bookId === currentChapter || activity.chapter === currentChapter),
        );

        const currentPageActivities = filter(
            currentBookActivities,
          (activity) => activity?.page === String(currentPage),
        );
        
        let currentUnitActivities;
        if (bookDataInformate?.start && bookDataInformate?.finish
            // && String(currentChapter) === String(CHAPTER_ID_INFORMATE)
        ) {
            currentUnitActivities = filter(
              currentBookActivities,
              (activity) => {
                const activityPage = parseInt(activity?.page, 10);
                const startPage = parseInt(bookDataInformate.start, 10);
                const finishPage = parseInt(bookDataInformate.finish, 10);
                return activityPage >= startPage && activityPage <= finishPage;
              }
            );
        } else if ((bookDataBalcon?.start && bookDataBalcon?.finish && String(currentChapter) === String(CHAPTER_ID_BALCON))) {
            currentUnitActivities = filter(
              currentBookActivities,
              (activity) => {
                const activityPage = parseInt(activity?.page, 10);
                const startPage = parseInt(bookDataBalcon.start, 10);
                const finishPage = parseInt(bookDataBalcon.finish, 10);
                return activityPage >= startPage && activityPage <= finishPage;
              }
            );
        } else if (CHAPTER_STORY_PAGE?.start) {
            currentUnitActivities = filter(
                currentBookActivities,
                (activity) => {
                  const activityPage = parseInt(activity?.page, 10);
                  const startPage = parseInt(CHAPTER_STORY_PAGE.start, 10);
                  const finishPage = parseInt(CHAPTER_STORY_PAGE.finish, 10);
                  return activityPage >= startPage && activityPage <= finishPage;
                }
              );
        } else if (currentUnit?.startPage) {
            currentUnitActivities = filter(
              currentBookActivities,
              (activity) =>
                activity?.page >= parseInt(currentUnit.startPage, 10) &&
                activity?.page <= parseInt(currentUnit.finishPage, 10),
            );
        } else {
            currentUnitActivities = currentPageActivities;
        }

        return currentUnitActivities.map(activity => {
            const isAssigned = allClassAssignments && allClassAssignments.some(classActivity => 
                (classActivity.activityId === activity.id || classActivity.quizId === activity.id)
            );
            const isCurrent = activity.id === data.id;
            
            return {
                ...activity,
                label: activity.displayName || activity.title || `Activity ${activity.id}`,
                value: activity.id,
                isAssigned: isAssigned,
                isCurrent: isCurrent
            };
        }).sort((a, b) => parseInt(a.page, 10) - parseInt(b.page, 10));
    }, [activities, quizzes, classActivities, classQuizzes, currentChapter, currentUnit, bookDataInformate, bookDataBalcon, data.id, CHAPTER_STORY_PAGE]);
    
    const is_soy_story = useMemo(() => data && ((typeof data.storyInstruction == "string" && data.storyInstruction.length > 0) || (data?.data && typeof data?.data.storyInstruction == "string" && data?.data.storyInstruction.length > 0)), [data])
    const is_article_level = useMemo(() => data && ((typeof data.article_level_id == "string" && data.article_level_id.length > 0) || (data?.data && typeof data?.data.article_level_id == "string" && data?.data.article_level_id.length > 0)), [data])
    const is_worksheet = useMemo(() => data && data?.data?.type === 'worksheet' || data?.data?.assignmentType === 'worksheet', [data])
    const coverTitle = useAssignmentCoverTitle({ assignment: data });
    const linkedClassesBySection = useMemo(() => groupLinkedSection(userClasses || [], isSchoologyUser), [userClasses, isSchoologyUser])
    const isCurrentClassLinked = useMemo(() => {
        if (!currentClass?.id) return false
        return Object.values(linkedClassesBySection).some(group =>
            group.some(c => String(c.id) === String(currentClass.id))
        )
    }, [currentClass?.id, linkedClassesBySection])
    const linkedGroupForCurrent = useMemo(() => {
        if (!currentClass?.id) return []
        return Object.values(linkedClassesBySection).find(g =>
            g.some(c => String(c.id) === String(currentClass.id))
        ) || []
    }, [currentClass?.id, linkedClassesBySection])
    const linkedClassNamesList = useMemo(() =>
        linkedGroupForCurrent.map(c => c.displayName && c.code ? `${c.displayName}` : c.displayName || c.id),
        [linkedGroupForCurrent]
    )
    const dataClassesIncludeOtherLinked = useMemo(() => {
        const dataClasses = get(data, "classes", [])
        if (!currentClass?.id || dataClasses.length === 0) return false
        const linkedIds = new Set(linkedGroupForCurrent.map(c => String(c.id)))
        return dataClasses.some(c => String(c.id) !== String(currentClass.id) && linkedIds.has(String(c.id)))
    }, [data, linkedGroupForCurrent, currentClass?.id])
    useEffect(() => {
        if(isEditing || data?.rubrics_id){
            const rubricId = get(data, "rubrics_id", null);
            const getRubric = find(AllRubricsData, (data) => data.id === rubricId);
            setAddedRubric({...getRubric,new:false})
            handleRubric(getRubric)
        }
      
    },[])

    useEffect(() => {
        if (data) {
            const todayDtime = moment().toISOString()
            const nextDtime = moment().add(1, "day").toISOString()
            const dueDate = get(data, "dueDate")
            const scheduleAt = get(data, "scheduleAt")
            const scheduleMoment = scheduleAt ? moment(scheduleAt) : moment(todayDtime)
            const defaultDueDate = scheduleMoment
                .clone()
                .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
                .toISOString()
            const incomingAiConfig = get(data, "ai_grading_config", {})
            const hasIncomingAiConfig = incomingAiConfig && Object.keys(incomingAiConfig).length > 0
            setAi_grading_config((prev) => {
                const hasPrevAiConfig = prev && Object.keys(prev).length > 0
                if (hasIncomingAiConfig) {
                    return incomingAiConfig
                }
                return hasPrevAiConfig ? prev : incomingAiConfig
            })
            
            
            // Add current assignment to selectedAssignments
            const currentSelectedAssignments = data.selectedAssignments || [];
            const currentAssignmentId = data.id;
            if (currentAssignmentId && !currentSelectedAssignments.includes(currentAssignmentId)) {
                handleChange({ 
                    target: { 
                        id: "selectedAssignments", 
                        value: [...currentSelectedAssignments, currentAssignmentId] 
                    } 
                });
            }
            
            if (!dueDate) {
                handleChange({ target: { id: "dueDate", value: defaultDueDate } })
            }
            if (!scheduleAt) {
                handleChange({ target: { id: "scheduleAt", value: todayDtime } })
            }
            if (currentClass && get(data, "classes", [])?.length == 0) {
                const v = {
                    target: {
                        id: "classes", value: [{
                            displayName:  `${currentClass.displayName} (${currentClass.code})`,
                            id: currentClass.id,
                            dueDate: data.dueDate ? data.dueDate : defaultDueDate,
                            scheduleAt: data.scheduleAt ? data.scheduleAt : todayDtime,
                            sectionId:currentClass.sectionId,
                            schoologyCategory:data.schoologyCategory,
                            diff:{
                                id: currentClass.id,
                                retakesDif:0,
                                levelExercise: 'hard',
                                dueDateDif: moment().add(1, 'day').toISOString(),
                                scheduleAtDiff: moment().toISOString(),
                                student: [],
                                timeDuration: 0
                            }
                        }]
                    }
                }
                handleChange(v)
            }
            if (get(data, "editing")) {
                if(!initialData||get(initialData, "id") !== get(data, "id")){
                    setInitialData(data)
                }
                if (get(prevData.current, "id") === get(data, "id")) {
                    if (!initialDueDate) {
                        setInitialDueDate(get(data, "dueDate"))
                    }
                    if (!initialLateDate) {
                        if(isBeforTime(get(data, "lateDate"),get(data, "dueDate"))){
                            setInitialLateDate(null)

                        }else{
                            setInitialLateDate(get(data, "lateDate"))
                        }
                    }

                } else {
                    setInitialDueDate(get(data, "dueDate"))
                    setInitialLateDate(get(data, "lateDate"))
                }

            } else {
                setInitialData(null)
                setInitialDueDate(null)
                setInitialLateDate(null)
            }
        }
        prevData.current= data
    }, [data])

       useEffect(() => {
            if(data?.id !== initData?.id){
                setInitData(data);
            }
        }, [data?.id])

    useEffect(() => {
        const momentLib = moment;
        const activityId = data?.data?.id||data?.id;
        if (!activityId || !currentUser?.id) {
            setAlreadyAssignedClassIds([]);
            return;
        }
        let cancelled = false;
        handleGetAssignmentStatus(activityId, currentUser.id)
            .then((status) => {
                if (cancelled) {
                    return;
                }
                if (!Array.isArray(status) || status.length === 0) {
                    setAlreadyAssignedClassIds([]);
                    return;
                }
                const assignedIds = map(status, (k) => k.classId).filter(Boolean);
                setAlreadyAssignedClassIds(assignedIds);
                if (isEditing) {
                    return;
                }
                const existingClasses = get(data, "classes", []) || [];
                if (existingClasses.length > 0) {
                    return;
                }
                const statusMap = new Map();
                status?.forEach((item) => {
                    const classId = item.classId;
                    let schoologyCategory, canvasAssignmentCategory;
                    if (Array.isArray(item.classes)) {
                        const match = item.classes.find((c) => c.id === classId);
                        schoologyCategory = match?.schoologyCategory;
                        canvasAssignmentCategory = match?.canvas_assignment_catrgory;
                    }
                    statusMap.set(String(classId), { schoologyCategory, canvasAssignmentCategory });
                });
                const assignedIdSet = new Set(assignedIds.map((id) => String(id)));
                const isAssigned = (id) => id != null && assignedIdSet.has(String(id));
                const todayDtime = momentLib().toISOString();
                const defaultDueDate = get(data, "dueDate") || momentLib().set({ hour: 23, minute: 59, second: 59, millisecond: 0 }).toISOString();
                const buildClassConfig = (classId, uc, statusSchoology, statusCanvasAssignmentCategory) => ({
                    id: classId,
                    displayName: uc ? `${uc.displayName} (${uc.code})` : classId,
                    dueDate: get(data, "dueDate") || defaultDueDate,
                    scheduleAt: get(data, "scheduleAt") || todayDtime,
                    sectionId: uc?.sectionId,
                    schoologyCategory: statusSchoology,
                    canvas_assignment_catrgory: statusCanvasAssignmentCategory,
                    diff: {
                        id: classId,
                        retakesDif: 0,
                        levelExercise: 'hard',
                        dueDateDif: momentLib().add(1, 'day').toISOString(),
                        scheduleAtDiff: momentLib().toISOString(),
                        student: [],
                        timeDuration: 0
                    }
                });
                const merged = assignedIds.map((classId) => {
                    const uc = find(userClasses, (u) => u.id === classId || u.id === String(classId));
                    const statusSchoology = statusMap.get(String(classId));
                    return buildClassConfig(classId, uc, statusSchoology?.schoologyCategory, statusSchoology?.canvasAssignmentCategory);
                });
                if (currentClass?.id && !isAssigned(currentClass.id)) {
                    const statusSchoology = statusMap.get(String(currentClass.id));
                    merged.push(buildClassConfig(currentClass.id, currentClass, statusSchoology?.schoologyCategory, statusSchoology?.canvasAssignmentCategory));
                }
                if (merged.length > 0) {
                    handleChange({ target: { id: "classes", value: merged } });
                }
            })
            .catch((err) => {
                setAlreadyAssignedClassIds([]);
            });
        return () => { cancelled = true; };
    }, [data?.id, data?.data?.id, isEditing, currentUser?.id])

    
    const onSubmit = (e) => {

        // if (data?.timeDuration) {
        //     const notificationData = {
        //         classId: get(currentClass, 'id', ''),
        //         displayName: get(data, 'displayName', ''),
        //         userId: get(currentUser, 'id', ''),
        //         modified: new Date(),
        //         data: {
        //             chapter: get(data, 'data.chapter', ''),
        //             page: get(data, 'data.page', ''),
        //             id: get(data, 'data.id', ''),
        //         },
        //         message: `Your Teacher Updated this Activity`,
        //         createdBy: get(currentClass, 'id', ''),
        //         type: 'update_activity',
        //         seen: true
        //     }
        //     sendNotifications(notificationData)
        // }
        if (isNaN(parseInt(data?.timeDuration))) {
            let v = { target: { id: "timeDuration", value: 0 } }
            handleChange(v)
        }
        if (!submissionLoading) {
            setSubmissionLoading(true);
        }
        handleSubmit(e);
    };


    const sendNotifications = async (notificationData) => {
        try {
            createCollectionNotification(notificationData, get(currentClass, 'id', ''));
        } catch (error) {
            Sentry.captureException(`566 Error in sendNotifications: ${error}`);
            console.log(error, "error")
        }
    }

    useEffect(() => {
        setSubmissionLoading(loading)
    }, [loading])
    const pageCover = usePageCover({ assignmentData: data?.data || data });
    const getImages = React.useCallback(() => {
        let _chapter = data.chapter ? data.chapter : data?.data?.chapter;
        if(pageCover){
            return pageCover;
        }
        else if (is_soy_story) {
            return SoyHistoriasNew;
        }
        else if (is_article_level) {
            return SoyStoryImg;
        }
        let _page = data.page ? data.page : data?.data?.page;
        let url =  imageFetchFromPodcast(_chapter,resources) ? imageFetchFromPodcast(_chapter,resources) : imageFetchDinamic(_chapter, _page, booksAllList)?.resource
        return url;
    })
    const graphicImage = React.useMemo(() => {
        if(data.activity_type ==="graphic_organizer"||data?.data?.activity_type ==="graphic_organizer"){
            let _page = data.assignment_page ? data.assignment_page : data?.data?.assignment_page;
            return graphic_data.find(k=>k.pageId == _page)?.thumbnail
        }else{
            return null;
        }
        
    },[data])
    const deleteActivity = async (e) => {
        e.preventDefault();
        setDataLoading(true);
        let classAssignmentIdsToDelete = [];
        if (data?.classes?.length > 0) {
            classAssignmentIdsToDelete = currentClass?.id ? [currentClass?.id] : [];
        } else {
            classAssignmentIdsToDelete = [String(data?.id)];
        }
        
        if (currentClass.sectionId) {
            await handleDeleteSchoologyAssignment(currentUser.schoologyid,data.activityId || data.quizId, classAssignmentIdsToDelete)
            listSchoologyAssignment(currentClass.sectionId)
        }
        if(currentClass.googleId){
            await handleDeleteGoogleAssignment(currentUser.googleId,data.activityId || data.quizId, classAssignmentIdsToDelete)
        }
        if(currentUser.canvas_id){
            try {
                await handleDeleteCanvasAssignment(currentUser.canvas_id,data.activityId || data.quizId, classAssignmentIdsToDelete, currentUser.canvas_auth_id);
            } catch (error) {
                Sentry.captureException(`567 Error in handleDeleteCanvasAssignment: ${error}`);
            }
        }
        const notificationData = {
            id: v4(),
            classId: get(currentClass, "id", ""),
            displayName: get(data, "displayName", ""),
            senderId: get(currentUser, 'id', ''),
            receiversId: filterClassUsers,
            modified: moment().toISOString(),
            data: {
                chapter: get(data, "data.chapter", ""),
                page: get(data, "data.page", ""),
                id: get(data, "data.id", ""),
            },
            message: `Your teacher Delete this Assignment`,
            type: "delete_activity",
            userSeen: []
        };
        if (onDelete) {
            onDelete(onDeleteSuccess)
            return;
        }
        await dispatch(handleDeleteClassActivity(
            data.activityId,
            data.classId
        ));
        onDeleteSuccess()
        sendNotifications(notificationData);
    };
    const onDeleteSuccess = () => {
        setdeleteClassAssignedActivityToggle(false);
        setDataLoading(false);
        onClose && onClose();
    }
    const updateClassConfig = (i,key,value)=>{
        const v = map(data.classes,(k)=>{
            if(k.id===i){
                k[key]=value;
                return k;
            }else{
                return k;
            }
        })
        let val = { target: { id: "classes", value: v } }
        handleChange(val)
    }
    const dateTimeSet = (key, value) => {
        try {
            let v = value.toISOString()
            if (key === "dueDate" && data.classes?.length && currentClass?.id) {
                const updatedClasses = data.classes.map((c) => {
                    if (String(c.id) !== String(currentClass.id)) return c
                    return {
                        ...c,
                        dueDate: v,
                        diff: c.diff ? { ...c.diff, dueDateDif: v } : c.diff
                    }
                })
                handleChange({ target: { id: "classes", value: updatedClasses } })
            }
            handleChange({ target: { id: key, value: v } })
        } catch (error) {
            Sentry.captureException(`568 Error in dateTimeSet: ${error}`);
        }
    }
    const getMinDate = (date1, date2) => {
        if (date1 && date2) {
            return isBeforTime(date1, date2) ? moment(date2).add(1, "minute").toISOString() : moment(date1).add(1, "minute").toISOString();
        } else if (date1 || date2) {
            return date1 ? moment(date1).add(1, "minute").toISOString() : moment(date2).add(1, "minute").toISOString();
        } else {
            return moment().toString()
        }
    }

    const hasClassConfigError = () => {
        const v = errorForDateConfig.classCnfError.filter(k => Object.values(k).filter(v => v).length > 0)
        return v.length > 0
    }
    const hasSubmitbuttonDeactive = () => {
        if (!data.dueDate || errorForDateConfig.dueDate) return true;
        if (isSchoologyUser && schoologyGradeCategory.length == 0) return true;
        else if (get(data, "lateDate") && errorForDateConfig.lateDate) return true;
        else if (loading || submissionLoading || hasClassConfigError()) return true;
        else if(moment(data.dueDate).isBefore(data.scheduleAt)) return true;
        else if(data.lateDate&&moment(data.lateDate).isBefore(data.dueDate)) return true;
        else return false;
    }
    const getStartMintime = (value) => {
        if (get(data, "editing") && value ) {
            return isBeforTime(moment(value).toISOString()) ? moment(value).toISOString(): moment().toISOString()
        } else {
            return moment().toISOString()
        }
    }
    const getDueMinDate = () =>{
        if(!!initialDueDate){
            return  isBeforTime(initialDueDate)?initialDueDate:moment() ;
        }else{
            return getMinDate(get(data, "scheduleAt"))
        }
    }
    const getMinLateDate = () =>{
        if(!!initialLateDate){
            const  _dueDate = get(data, "dueDate")
            return  isBeforTime(initialLateDate)?initialDueDate:getMinDate(_dueDate,moment()) ; 
        }else{
            const  _dueDate = get(data, "dueDate")
            const _scheduleAt = get(data, "scheduleAt")
            const minScheduledDate = getMinDate(_scheduleAt)
           return  getMinDate(_dueDate,minScheduledDate)
        }
    }
    const openDueDateAlert = () =>{
        setAlert({
            open: true,
            message:`Assigning activities with due dates beyond the current semester is not possible.`
        })
    }
    const closeDueDateAlert = () =>{
        setAlert({open:false,message:''})
    }

    const fetchIsVideos = () => {
        let _chapter = data.chapter ? data.chapter : data?.data?.chapter;
        const videoData = isVideo(_chapter, resources)
        return videoData;
    }
    const isResourceVideo = fetchIsVideos();
    const is_not_sync = () => typeof data?.no_sync === "boolean" ? data.no_sync : false
    const sync_msgs = () => {
        if (isSchoologyUser) {
            return `Do not sync with Schoology.`
        } else if (isCanvas_user) {
            return `Do not sync with Canvas.`
        } else {
            return `Do not sync with Google Classroom.`
        }
    }

    const getMaskIdForMultipleAssignments = (option) => {
        if (UNIT_PAGES.length > 0) {
            const pageIndex = findIndex(UNIT_PAGES, p => p.pageId == get(option, "page", ''))
            return pageIndex >= 0 ? pageIndex + 1 : (get(option, "page", '') - parseInt(bookDataInformate.start, 10) + 1)
        } else if (CHAPTER_STORY_PAGE.start) {
            return ((get(option, "page", '') - parseInt(CHAPTER_STORY_PAGE.start, 10) + 1));
        } else {
            return getNumberMask(get(option, "chapter", 'bookId'), get(option, "page", ''), booksAllList);
        }
    }
    const is_no_sync = is_not_sync()
    const is_integration = isSchoologyUser || isCanvas_user || isGoogleUser
    const hasGradeCatMissing = filter(data.classes,c=> isSchoologyUser&&!is_no_sync&&!c.schoologyCategory && !alreadyAssignedClassIds.includes(c.id))
    const hasGradeCatMissingForCanvas = filter(data.classes,c=>isCanvas_user&&!is_no_sync&&!c.canvas_assignment_catrgory)
    const submitButtonDeactive = hasGradeCatMissing.length>0|| hasSubmitbuttonDeactive() || hasGradeCatMissingForCanvas.length>0

    useEffect(()=>{
        if(addedRubric?.id && addedRubric.new){
         handleChange({ target: { id: "max_point", value: addedRubric?.max_point} })
        }

    },[addedRubric?.id])

    const closeGraphicOrganizerEditModal = () => {
        setGraphicOrganizerEditModalOpen(false)
    }


    const handleEdit = () => {
        const matchedObj = find(graphic_activity, (obj) => obj.id == data.id || obj.displayName == data.displayName);
        const label_position = get(matchedObj, "label_position", []) || [];
        if (label_position && label_position.length > 0) {
            setGraphicOrganizerEditModalOpen(true)
        } else {
            showAlert("Instructions are required to edit this assignment.", "error");
        }
    }
        

    return (
        <SentryWrap>
            <Wrapper onSubmit={onSubmit}>
          

              <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={openAlert.open}
                autoHideDuration={3000}
                onClose={closeDueDateAlert}>
                <Alert onClose={closeDueDateAlert} severity="error">
                    <strong>ALERT:</strong> {openAlert.message}
                </Alert>
            </Snackbar>
            <Modal
                open={deleteClassAssignedActivityToggle}
                onClose={() => setdeleteClassAssignedActivityToggle(false)}
            >
                <ModalContent>
                    Are you sure you want to delete the assignment? All grades will be removed as well.
                    <ModalRow>
                        <Button
                            style={{ marginRight: '4px' }}
                            onClick={() => setdeleteClassAssignedActivityToggle(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={deleteActivity}
                            className={`${dataLoading ? "disabled" : ""}`}
                        >
                            {dataLoading ? <Loading size={20} white /> : 'Yes'}
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>
        
          
            <Row className='customImgContainRow' style={{flexDirection:deviceType ? 'column' : 'row'}}>
                <Col xs={24} sm={12} md={12} style={{ padding: "16px 10px", minWidth: deviceType ? '100%' : 'initial'}}>
                    <ImageContiner className='customImgContain'>
                    {coverTitle ? <label className='customImgTitle'>{coverTitle}</label> : null}
                        <Image src={getImages()} alt='' />
                    </ImageContiner>
                </Col>
                <Col xs={24} sm={12} md={12} style={{ padding: "16px 16px", flex: deviceType ? 1 : 'unset', minWidth: deviceType ? '100%' : 'initial' }}>
                    <Header>{data?.editing ? `Edit ${data?.data?.is_exam ? 'Examen' : data?.data?.is_unit_exam ? 'Unit Exam' : 'Activity'}` : `Assign ${data?.is_exam ? 'Examen' : data?.is_unit_exam ? 'Unit Exam' : 'Activity'}`}</Header>
                    <Description>Please, remember the activity due date is to create a logic that will automatically make the activity disappear from the student dashboard. If you want to make it visible after this date, you can go back and edit the details.</Description>
                    {graphicImage ? (
                        <GraphicImageWrapper>
                            <Image src={graphicImage} alt='' style={{ width: 100 }} />
                            {/* {isEditing && ( */}
                                <EditIconButton 
                                    size="small"
                                    onClick={handleEdit}
                                >
                                    <Edit style={{ fontSize: 16 }} />
                                </EditIconButton>
                            {/* )} */}
                        </GraphicImageWrapper>
                    ) : null}
                    <Row gutter={[16, 24]}>
                        <Col span={24}>
                            <Acent inputRef={dispNameRef} setValue={(v) => handleChange(customEvent("displayName", v))} style={{ marginBottom: 5 ,  display:"flex" ,justifyContent:"flex-end"  }}/>
                            <DisabledInputWrapper isDisabled={data?.selectedAssignments?.filter(id => id !== data?.id).length > 0}>
                                <TextField
                                    id="displayName"
                                    label="Display name"
                                    inputRef={dispNameRef}
                                    type="text"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChange}
                                    variant="outlined"
                                    value={data?.displayName ?? data?.data?.displayName ?? ''}
                                    disabled={data?.selectedAssignments?.filter(id => id !== data?.id).length > 0}
                                />
                            </DisabledInputWrapper>
                            {data?.selectedAssignments?.filter(id => id !== data?.id).length > 0 && (
                                <div style={{ marginTop: 8, display:'flex', alignContent:'center', gap:5 }}>
                                    <Tag height={20}><Star style={{ height: '12px', margin: '-1px 4px 0px 0px', width: '12px' }} /> NOTE</Tag>
                                    <Note>The default title will be respected for each activity.</Note>
                                </div>
                            )}
                        </Col>
                    </Row>
                    {!isEditing && !isExternalToolMode && (isGoogleUser || isSchoologyUser) && (
                    // {(isEditing || isResourceVideo || isCanvas_user || isSchoologyUser) ? null : (
                    <Row gutter={[16, 24]} style={{ marginTop: '24px', marginBottom: '24px' }}>
                        <Col span={24}>
                            <Autocomplete
                                multiple
                                id="assignmentDropdown"
                                options={assignmentOptions}
                                getOptionLabel={(option) => option.label}
                                value={assignmentOptions.filter(option => 
                                    (data.selectedAssignments || []).includes(option.value)
                                )}
                                onChange={(event, newValue) => {
                                    const selectedValues = newValue.map(item => item.value);
                                    const currentAssignmentId = data.id;
                                    
                                    const filteredSelectedValues = selectedValues.filter(value => {
                                        const option = assignmentOptions.find(opt => opt.value === value);
                                        return !option?.isAssigned;
                                    });
                                    
                                    const finalSelectedValues = currentAssignmentId && !filteredSelectedValues.includes(currentAssignmentId) 
                                        ? [...filteredSelectedValues, currentAssignmentId]
                                        : filteredSelectedValues;
                                    
                                    handleChange({ 
                                        target: { 
                                            id: "selectedAssignments", 
                                            value: finalSelectedValues 
                                        } 
                                    });
                                }}
                                disableCloseOnSelect
                                freeSolo
                                slotProps={{
                                    popper: {
                                        modifiers: [
                                            {
                                                name: 'offset',
                                                options: {
                                                    offset: [0, 8],
                                                },
                                            },
                                        ],
                                    },
                                }}
                                inputValue={searchInputValue}
                                onInputChange={(event, newInputValue) => {
                                    setSearchInputValue(newInputValue || "");
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params} 
                                        label="Select Assignments"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                )}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props} key={option.id} style={{ 
                                        padding: '8px 16px',
                                        fontSize: '14px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: (option.isAssigned || option.isCurrent) ? 'not-allowed' : 'pointer',
                                    }}>
                                        <Checkbox
                                            checked={(data.selectedAssignments || []).includes(option.value) || option.isAssigned || option.isCurrent}
                                            disabled={option.isAssigned || option.isCurrent}
                                            style={{ marginRight: '8px' }}
                                            onChange={(e) => {
                                                if (option.isAssigned || option.isCurrent) {
                                                    e.preventDefault();
                                                    return;
                                                }
                                                e.stopPropagation();
                                                const currentSelected = data.selectedAssignments || [];
                                                const newValue = e.target.checked 
                                                    ? [...currentSelected, option.value]
                                                    : currentSelected.filter(val => val !== option.value);
                                                handleChange({ 
                                                    target: { 
                                                        id: "selectedAssignments", 
                                                        value: newValue 
                                                    } 
                                                });
                                            }}
                                        />
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                            {option.label}
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            {option.isCurrent && (
                                                <span style={{ 
                                                    fontSize: '14px', 
                                                    padding: '2px 6px', 
                                                    borderRadius: '10px',
                                                    backgroundColor: '#e3f2fd',
                                                    color: '#1976d2',
                                                    fontWeight: '500'
                                                }}>
                                                    Current
                                                </span>
                                            )}
                                            {option.isAssigned && (
                                                <span style={{ 
                                                    fontSize: '14px', 
                                                    padding: '2px 6px', 
                                                    borderRadius: '10px',
                                                    backgroundColor: '#e8f5e8',
                                                    color: '#2e7d32',
                                                    fontWeight: '500'
                                                }}>
                                                    Assigned {option.maskId ? `(${option.maskId})` : ''}
                                                </span>
                                            )}
                                            {!isResourceVideo && (
                                                <span style={{ 
                                                    fontSize: '14px', 
                                                    padding: '2px 6px', 
                                                    borderRadius: '10px',
                                                    backgroundColor: '#e8f5e8',
                                                    color: '#2e7d32',
                                                    fontWeight: '500',
                                                    display: 'inline-block',
                                                    width: '80px',
                                                    textAlign: 'center'
                                                }}>
                                                    Page: {getMaskIdForMultipleAssignments(option)}
                                                </span>
                                            )}
                                            </div>
                                        </div>
                                    </li>
                                )}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => {
                                        const tagProps = getTagProps({ index });
                                        if (option.isCurrent) {
                                            delete tagProps.onDelete;
                                        }
                                        return (
                                            <Chip
                                                {...tagProps}
                                                key={option.id}
                                                sx={{
                                                    height: 'auto',
                                                    minHeight: '32px',
                                                    '& .MuiChip-label': {
                                                        whiteSpace: 'normal',
                                                        wordBreak: 'break-word',
                                                        padding: '4px 8px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-start',
                                                        gap: '4px'
                                                    }
                                                }}
                                                label={
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#000', flexWrap: 'wrap' }}>
                                                        <span style={{ wordBreak: 'break-word', lineHeight: '1.2' }}>{option.label}</span>
                                                        <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                                                            {option.isCurrent && (
                                                                <span style={{ 
                                                                    fontSize: '12px', 
                                                                    padding: '1px 4px', 
                                                                    borderRadius: '8px',
                                                                    backgroundColor: '#e3f2fd',
                                                                    color: '#1976d2',
                                                                    fontWeight: '500'
                                                                }}>
                                                                    Current
                                                                </span>
                                                            )}
                                                            {option.isAssigned && (
                                                                <span style={{ 
                                                                    fontSize: '12px', 
                                                                    padding: '1px 4px', 
                                                                    borderRadius: '8px',
                                                                    backgroundColor: '#e8f5e8',
                                                                    color: '#2e7d32',
                                                                    fontWeight: '500'
                                                                }}>
                                                                    Assigned {option.maskId ? `(${option.maskId})` : ''}
                                                                </span>
                                                            )}
                                                            {!isResourceVideo && (
                                                                <span style={{ 
                                                                    fontSize: '11px', 
                                                                    padding: '2px 6px', 
                                                                    borderRadius: '10px',
                                                                    backgroundColor: '#e8f5e8',
                                                                    color: '#2e7d32',
                                                                    fontWeight: '500',
                                                                    display: 'inline-block',
                                                                    width: '70px',
                                                                    textAlign: 'center'
                                                                }}>
                                                                    Page: {getMaskIdForMultipleAssignments(option)}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                }
                                                color={option.isCurrent ? "info" : option.isAssigned ? "success" : "primary"}
                                                variant="outlined"
                                                size="small"
                                                style={{ margin: '2px' }}
                                            />
                                        );
                                    })
                                }
                                isOptionEqualToValue={(option, value) => option.value === value?.value}
                                noOptionsText="No assignments found"
                                sx={{
                                    '& .MuiAutocomplete-popupIndicator': {
                                        color: '#666',
                                    },
                                    '& .MuiAutocomplete-clearIndicator': {
                                        color: '#666',
                                    }
                                }}
                            />
                        </Col>
                    </Row>)}
                    <Row gutter={[16, 24]} className="durDateSpc">
                        <Col span={24}>
                            <CustomDateTimePicker
                                id="scheduleAt"
                                label="Start date"
                                inputVariant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                format="MM-dd-yyyy hh:mm a"
                                minDate={moment().subtract(1, 'day').toISOString()}
                                minDateMessage="Start date must be before today's date"
                                defaultValue={null}
                                initialFocusedDate={moment().toString()}
                                value={get(data, "scheduleAt")}
                                onChange={e => {
                                    dateTimeSet("scheduleAt", e)
                                }}
                            />
                            {data.scheduleAt && data.dueDate && moment(data.scheduleAt).isAfter(data.dueDate) && (
                                <div style={{marginTop:5}}>
                                    <Note style={{color:COLOR.red , fontSize:11, margin:0}}>Start date must be before the due date.</Note>
                                </div>
                            )}
                            {data.scheduleAt && data.lateDate && moment(data.scheduleAt).isAfter(data.lateDate) && (
                                <div style={{marginTop:5}}>
                                    <Note style={{color:COLOR.red , fontSize:11, margin:0}}>Start date must be before the late date.</Note>
                                </div>
                            )}
                        </Col>
                        <div className='assimentSecudleDate'>
                            <Tag height={20}><Star style={{ height: '12px', margin: '-1px 4px 0px 0px', width: '12px' }} /> NOTE</Tag>
                            <Note style={{marginBottom:0}}>The assignment will take effect after the scheduled date and time.</Note>
                        </div>
                    </Row>
                    <Row gutter={[16, 24]} className="durDateSpc">
                        <Col span={24}>
                        <CustomDateTimePicker
                                id="dueDate"
                                label="Due Date"
                                inputVariant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                format="MM-dd-yyyy hh:mm a"
                                minDate={getDueMinDate()}
                                initialFocusedDate={moment().toString()}
                                strictCompareDates
                                //minDateMessage={"Due Date and Time has to be after the Start Date and Time."}
                                defaultValue={null}
                                value={get(data, "dueDate")}
                                onChange={e => {
                                    if(!isBeforTime(e,currentSemDateAndTime.start)&& !isAfterTime(e,currentSemDateAndTime.end)){
                                        dateTimeSet("dueDate", e)
                                        setInitialLateDate(null)
                                    }else{
                                        openDueDateAlert()
                                    }
                                }}
                                 />
                        {data.scheduleAt && data.dueDate && moment(data.dueDate).isBefore(data.scheduleAt) && (
                            <div style={{marginTop:5}}>
                                <Note style={{color:COLOR.red , fontSize:11, margin:0}}>Due Date and Time has to be after the Start Date and Time.</Note>
                            </div>
                        )}
                        </Col>
                        <div className='assimentSecudleDate'>
                            <Tag height={20}><Star style={{ height: '12px', margin: '-1px 4px 0px 0px', width: '12px' }} /> NOTE</Tag>
                            <Note style={{marginBottom:0}}>Due at midnight from the chosen date.</Note>
                        </div>
                    </Row>

                    {/* Shuffle start */}
                    <Container className='asignActivityUpr'>
                        <Row justify="start" style={{ marginBottom: 10 }}>
                            <StyledFormControlLabel
                                className="rootDif"
                                control={
                                    <StyledSwitch
                                        checked={data.shuffled}
                                        disabled={isEditing}
                                        id="shuffled"
                                        onChange={e => {
                                            let v = { target: { id: "shuffled", value: e.target.checked } }
                                            handleChange(v)
                                        }}
                                        name="shuffled"
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={<StyledLabel>Shuffle</StyledLabel>}
                            />
                        </Row>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginTop: 14,marginBottom:35 }}>

                            <Tag height={20}><Star style={{ height: '12px', margin: '-1px 4px 0px 0px', width: '12px' }} /> NOTE</Tag>
                            <Note style={{marginBottom:0}}>Questions will be rearranged on a per-student basis.</Note>
                            </div>
                    </Container>
                    {/* Shuffle End */}

                    {/* Late date field */}
                    <Container className='asignActivityUpr'>
                        <Row justify="start" style={{ marginBottom: 10 }}>
                            <StyledFormControlLabel
                                className="rootDif"
                                // disabled={is_exam}
                                control={
                                    <StyledSwitch
                                        checked={data.lateDate}
                                        id="lateSubmissionSection"
                                        onChange={e => {
                                            if (e.target.checked) {
                                                let v = { target: { id: "lateDate", value: isBeforTime(get(data, "dueDate"))? moment().add(1,"hour").toISOString(): getMinDate(get(data, "dueDate"),moment()) } }
                                                handleChange(v)
                                            } else {
                                                let v = { target: { id: "lateDate", value: null } }
                                                handleChange(v)
                                            }
                                        }}
                                        name="lateSubmissionSection"
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={<StyledLabel>Late Submission</StyledLabel>}
                            />
                        </Row>
                        {get(data,"lateDate") ? <>
                            <Tag height={20}><Star style={{ height: '12px', margin: '-1px 4px 0px 0px', width: '12px' }} /> NOTE</Tag>
                            <Note>If you don't choose a date, it will be counted as "unlimited" time to submit this assessment.</Note>
                            <Row gutter={[16, 24]}>
                                <Col span={24}>
                                <CustomDateTimePicker
                                        id="lateDate"
                                        label="Late Submission"
                                        // disabled={is_exam}
                                        inputVariant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        format="MM-dd-yyyy hh:mm a"
                                        minDate={getMinLateDate()}
                                        initialFocusedDate={moment().toString()}
                                        minDateMessage={"Late Date and Time has to be after the Due Date and Time."}
                                        value={get(data, "lateDate")=="always"?undefined:get(data, "lateDate")}
                                        strictCompareDates
                                        defaultValue={null}
                                        onChange={e => {
                                            dateTimeSet("lateDate", e)
                                        }} />
                                </Col>
                            </Row>
                            <>
                            {data.lateDate && data.dueDate && moment(data.lateDate).isBefore(data.dueDate) && (
                                <div style={{marginTop:5}}>
                                    <Note style={{color:COLOR.red , fontSize:11, margin:0}}>Late Date and Time has to be after the Due Date and Time.</Note>
                                </div>
                            )}
                            {data.scheduleAt && data.lateDate && moment(data.lateDate).isBefore(data.scheduleAt) && (
                                <div style={{marginTop:5}}>
                                    <Note style={{color:COLOR.red , fontSize:11, margin:0}}>Late Date and Time has to be after the Start Date and Time.</Note>
                                </div>
                            )}
                           </>
                        </>:null
                        }
                    </Container>
                    {/* End late date field */}
                    {/* result view date */}
                   <Container>
                        <Row justify="start" style={{ marginBottom: 10 }}>
                            <StyledFormControlLabel
                                className="rootDif"
                                control={
                                    <StyledSwitch
                                        checked={data.result_visibility_on}
                                        id="lateSubmissionSection"
                                        onChange={e => {
                                            if (e.target.checked) {
                                                let v = { target: { id: "result_visibility_on", value: data.scheduleAt } }
                                                handleChange(v)
                                            } else {
                                                let v = { target: { id: "result_visibility_on", value: null } }
                                                handleChange(v)
                                            }
                                        }}
                                        name="result_visibility_on_section"
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={<StyledLabel>Result Visibility Date</StyledLabel>}
                            />
                        </Row>
                        {get(data,"result_visibility_on") ? <>
                            <Tag height={20}><Star style={{ height: '12px', margin: '-1px 4px 0px 0px', width: '12px' }} /> NOTE</Tag>
                            <Note>Set a results release date—students will see results after that date, or immediately if no date is set.</Note>
                            <Row gutter={[16, 24]}>
                                <Col span={24}>
                                <CustomDateTimePicker
                                        id="result_visibility_on"
                                        label="Result Visibility Date"
                                        inputVariant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        format="MM-dd-yyyy hh:mm a"
                                        minDate={data.scheduleAt}
                                        initialFocusedDate={moment().toString()}
                                        minDateMessage={"results releas  Date and Time has to be after the Start Date and Time."}
                                        value={data.result_visibility_on}
                                        strictCompareDates
                                        defaultValue={null}
                                        onChange={e => {
                                            dateTimeSet("result_visibility_on", e)
                                        }} />
                                </Col>
                            </Row>
                        </>:null
                        }
                    </Container>
                    {/* end of result date */}

                    <Container>
                        <Row justify="start" style={{ marginBottom: 10 }}>
                            <StyledFormControlLabel
                                className="rootDifFull"
                                control={
                                    <StyledSwitch
                                        // disabled={isEditing}
                                        checked={durationSection}
                                        id="timeDuration"
                                        onChange={e => {
                                            if (!e.target.checked) {
                                                let v = { target: { id: "timeDuration", value: 0 } }
                                                handleChange(v)
                                            }
                                            if (setDurationSection) {
                                                setDurationSection(e.target.checked)
                                                // let v = { target: { id: "timeDuration", value: 0 } }
                                                // handleChange(v)
                                            }
                                        }}
                                        name="timeDuration"
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={<StyledLabel>Set a TIME-LIMIT for this assessment</StyledLabel>}
                            />
                        </Row>
                   {/* {isEditing&&durationSection?<Note style={{ marginBottom: 0 ,  color:COLOR.radish100  }}>Time limit cannot be modified or removed after it has been assigned.</Note>:null} */}
                        
                        {durationSection &&
                            <Row gutter={[16, 24]} style={{ marginTop: 16 }}>
                                <Col span={24}>
                                    <TextField
                                        id="timeDuration"
                                        onChange={handleChange}
                                        variant="outlined"
                                        // disabled={isEditing}
                                        label={"Duration in minutes"}
                                        value={parseInt(data?.timeDuration ?? 0, 10)}
                                        type="number"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        InputProps={{
                                            inputProps: {
                                                min: 0,
                                                onWheel: (e) => e.target.blur()
                                            }
                                        }}
                                    />
                                </Col>
                            </Row>
                        }
                    </Container>
                    <Container>
                          <AssignmentClassConfig
                            userClasses={userClasses}
                            data={data}
                            handleChange={handleChange}
                            currentClass={currentClass}
                            errorForDateConfig={errorForDateConfig}
                            isSchoologyUser={isSchoologyUser}
                            schoologyAllClassGradeCategory={schoologyAllClassGradeCategory}
                            setErrorForDateConfig={setErrorForDateConfig}
                            is_exam={is_exam}
                            alreadyAssignedClassIds={data.editing ? [] : alreadyAssignedClassIds} />
                    </Container>

                  
                    <Container style={{ display: "flex", justifyContent: "start" }}>
                    <ModalMenu 
                    type={"selectRubricModal"} 
                    addedRubric={addedRubric} 
                    editable={data}
                    setAddedRubric={(val) => {
                        setAddedRubric({...val,new:true})
                        handleRubric(val)
                        handleChange({ target: { id: "grade_type", value : "points" } })
                    }}
                    resetConfig={()=> {
                        setAddedRubric({})
                        handleRubric({})
                    }}
                    />
            </Container>
            <AiConfiguration
                assignmentCategory={data?.category || ""}
                config={ai_grading_config}
                onChangeConfig={(conf) => {
                    setAi_grading_config(conf);
                    handleChange({ target: { id: "ai_grading_config", value: conf } });
                    if (conf?.grade_level) {
                        handleChange({ target: { id: "grade_level", value: conf.grade_level } });
                    }
                }}
                is_exam={is_exam}
                is_editing={Boolean(data?.editing)}
            />
                    
                    <Container>
                        <Row gutter={[16, 24]}>
                            <Col span={16}>
                                <Tag height={20}><Star style={{ height: '12px', margin: '-1px 4px 0px 0px', width: '12px' }} /> Weightage</Tag>
                                <Note style={{ marginBottom: 0 }}>This weightage is used to calculate grade.</Note>
                                <Note style={{ color: COLOR.red, fontSize: 10 }}>You will not be able to edit the weightage after assigning activity or quiz.</Note>
                                {/* {isSchoologyUser&& !get(data,"schoologyCategory")? <Note style={{ marginBottom: 0 , color:COLOR.radish100 }}>Weightage category required!</Note>:null}
                                {isSchoologyUser&& get(schoologyGradeCategory,"length")==0? <Note style={{ marginBottom: 0 ,  color:COLOR.radish100  }}>Please create category on schoology platform then try again!</Note>:null} */}
                            </Col>
                            <Col span={8}>
                            {((!isSchoologyUser && !isCanvas_user) || is_no_sync)  && !data.ungraded? 
                                    <TextField
                                        id="weightage"
                                        disabled={data.editing}
                                        onChange={(e) => {
                                            let val = e.target.value
                                            val = val > 100 ? data?.weightage : val
                                            let v = { target: { id: "weightage", value: val } }
                                            handleChange(v)
                                        }}
                                        variant="outlined"
                                        defaultValue={100}
                                        value={parseInt(data?.weightage ?? 100, 10)}
                                        type="number"
                                        InputProps={{
                                            inputProps: {
                                                min: 0,
                                                max: 100,
                                                onWheel: (e) => e.target.blur()
                                            }
                                        }}
                                    />:null}
                                {(!isSchoologyUser  && !isCanvas_user)||is_no_sync ? <StyledFormControlLabel
                                    className="rootDifFull"
                                    control={
                                        <StyledCheckbox
                                            checked={data.ungraded}
                                            id="ungraded"
                                            onChange={e => {
                                                handleChange({ target: { id: "ungraded", value: e.target.checked } })
                                            }}
                                            name="ungraded"
                                            color="primary"
                                            size="small"
                                        />
                                    }
                                    label={<StyledLabel>Ungraded</StyledLabel>}
                                /> : null}
                            </Col>
                        </Row>
                        {(!isSchoologyUser || is_no_sync) && <Row gutter={[16, 24]}>
                            <Col  xs={12} sm={12} md={8} lg={8} xl={8} xxl={8} >
                            <StyledFormControl variant="outlined">
                                        <InputLabel id="grade_type" style={{ backgroundColor: "#fff", width: 'max-content' }}>Display Grade as</InputLabel>
                                        <Select
                                            labelId="grade_type"
                                            disabled={data.editing}
                                            value={get(find(isCanvas_user?GRADE_TYPE_CANVAS:GRADE_TYPE_ALL,["value",data.grade_type]),"type","Percentage")}
                                            onChange={e => {
                                                handleChange({ target: { id: "grade_type", value :e.target.value } })
                                            }}
                                            renderValue={(selected) => {
                                                return (
                                                    <div >
                                                        <ListItemText primary={selected} />
                                                    </div>
                                                )
                                            }}
                                            MenuProps={MenuProps}
                                        >
                                            {map(isCanvas_user?GRADE_TYPE_CANVAS:GRADE_TYPE_ALL, (option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <ListItemText primary={`${option.type}`} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </StyledFormControl>
                            </Col>
                            <Col   sm={12} md={8} lg={4} xl={4} xxl={4} xs={12} style={{justifyContent:"center",alignItems:"center", display:"flex"}}>
                            {data.grade_type === 'points' ? <TextField
                                    id="max_point"
                                    defaultValue={100}
                                    disabled={data.editing}
                                    onChange={(e) => {
                                        handleChange({ target: { id: "max_point", value: e.target.value } })
                                    }}
                                    variant="outlined"
                                    value={data.max_point}
                                    className={"max_point"}
                                    type="number"
                                    InputProps={{
                                        inputProps: {
                                            min: 0
                                        }
                                    }}
                                    style={{height:50}}
                                /> : null}
                                
                            </Col>
                        </Row>}
                        {/* Final grade exclude section removed */}
                    </Container>
                    {/* Video section removed */}
                    <Container>
                        <Row gutter={[16, 24]} className='assigmentLstSec'>
                            <Col span={16}>
                                <Tag height={20}><Star style={{ height: '12px', margin: '-1px 4px 0px 0px', width: '12px' }} /> NOTE</Tag>
                                <Note>This is the number of additional attempts the student will have for this activity.</Note>
                            </Col>
                            <Col span={8}>
                                <TextField
                                    id="retakes"
                                    variant="outlined"
                                    onChange={(e) => {
                                        let val = e.target.value === "" ? 0 : parseInt(e.target.value, 10);
                                        val = val > 100 ? (data?.retakes ?? 0) : val;
                                        let v = { target: { id: "retakes", value: val } };
                                        handleChange(v);
                                    }}
                                    value={data?.retakes ?? 0}
                                    type="number"
                                    InputProps={{
                                        inputProps: {
                                            min: 0,
                                            max: 100,
                                            onWheel: (e) => e.target.blur()
                                        }
                                    }}
                                />
                            </Col>
                        </Row>
                    </Container>
                    
                    {/* Update to all classes section removed */}
                    {isSchoologyUser && hasGradeCatMissing.length>0  ? <Note style={{ marginBottom: 0, color: COLOR.radish100 }}>Weightage category is required for {`${hasGradeCatMissing.map(k=>k.displayName).join(',')}`}</Note> : null}
                    {isCanvas_user && hasGradeCatMissingForCanvas.length>0  ? <Note style={{ marginBottom: 0, color: COLOR.radish100 }}>Assignment category is required for {`${hasGradeCatMissingForCanvas.map(k=>k.displayName).join(',')}`}</Note> : null}
                    {isSchoologyUser && isCurrentClassLinked && dataClassesIncludeOtherLinked && !get(data, 'updateTOAllClass') && (
                        <div style={{ marginBottom: 16, display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                            <Tag height={20}><Star style={{ height: '12px', margin: '-1px 4px 0px 0px', width: '12px' }} /> NOTE</Tag>
                            <Note style={{ marginBottom: 0  , color: COLOR.radish100 }}>
                                Configuration will be applied to all linked classes. {linkedClassNamesList.length > 0 && `(${linkedClassNamesList.join(', ')})`}
                            </Note>
                        </div>
                    )}
                    <Row justify="space-between"  style={{marginBottom:16}} className='assigmentLstSec'>
                    <Col  sm={24} xs={24} md={10} lg={10} xl={10} xxl={10}   style={{ display: "flex",gap:10 ,alignItems:"flex-end"}} >
                        {(data.editing && !loading) && <Button
                            className='assigmentLstDelete'
                            color="secondary"
                            onClick={(e) => {
                                e.preventDefault()
                                setdeleteClassAssignedActivityToggle(true)
                            }}
                            variant="contained"
                            style={{ padding: '0px 0px !important' , height:30 , width:60 }}
                        >
                            <Delete style={{ fontSize: '16px', width: '16px' }} />
                        </Button>}
                        {is_integration && !isExternalToolMode ? <FormControlLabel
                                className="rootDifFull"
                                control={
                                    <StyledCheckbox
                                        checked={is_not_sync()}
                                        id="updateTOAllClass"
                                        onChange={e => {
                                            handleChange({ target: { id: "no_sync", value: e.target.checked } })
                                        }}
                                        name="no_sync"
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={sync_msgs()}
                            />:null}
                        </Col>
                        <Col  sm={24} xs={24} md={14} lg={14} xl={14} xxl={14}  style={{ display: "flex", alignItems: "flex-end", flexDirection:"column" }} >
                         {data.editing && data.classes && data.classes.length > 0 && <FormControlLabel
                                className="rootDifFull"
                                control={
                                    <StyledCheckbox
                                        checked={data.updateTOAllClass}
                                        id="updateTOAllClass"
                                        onChange={e => {
                                            handleChange({ target: { id: "updateTOAllClass", value: e.target.checked } })
                                        }}
                                        name="updateTOAllClass"
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label="Update to all classes."
                                sx={{color:'#FF0000'}}
                            />}
                        <Button
                            disabled={submitButtonDeactive}
                            variant="contained"
                            color="primary"
                            type='submit'
                            className='updateActvityBtn'
                            endIcon={<ArrowForward style={{ height: '18px', margin: '0px 0px 0px 6px', width: '18px' }} />}
                        >
                            {data.editing ? ((loading || submissionLoading) ? <Loading size={20} white /> : `${data?.data?.is_exam ? 'Update Examen' :data?.data?.is_unit_exam ? 'Update Unit Exam' : 'Update Activity'}`) : ((loading || submissionLoading) ? <Loading size={20} white /> : `${data?.is_exam ? 'Assign Examen' :data?.is_unit_exam ? 'Assign Unit Exam' : 'Assign Activity'} `)}
                        </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Modal
                open={graphicOrganizerEditModalOpen}
                onClose={closeGraphicOrganizerEditModal}
                className={"rubricsPopUp"}
                style={{ height: '100%', width: '100%', backgroundColor: "transparent" }}
                onContextMenu={e => {
                    e.preventDefault();
                }}
            >
                <GraphicOrganizerEditPreview
                    open={graphicOrganizerEditModalOpen}
                    setOpen={setGraphicOrganizerEditModalOpen}
                    assignment={data?.data || data}
                    ownGraphicOrganizer={ownGraphicOrganizer}
                    setTemplateType={setTemplateType}
                />
            </Modal>
        </Wrapper>
        </SentryWrap>
    );
};


const mapStateToProps = state => ({
    currentClass: state.currentClass,
    userClasses: state.userClasses,
    booksAllList: state.booksAllList,
    currentUser: state.currentUser
});


export default connect(mapStateToProps, null)(ActivityForm);